import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      scrolled: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const isScrolled = window.scrollY > 20;
    if (isScrolled !== this.state.scrolled) {
      this.setState({ scrolled: isScrolled });
    }
  };

  toggleMobile = () => {
    this.setState(prev => ({ mobileOpen: !prev.mobileOpen }));
  };

  closeMobile = () => {
    this.setState({ mobileOpen: false });
  };

  render() {
    const { mobileOpen, scrolled } = this.state;

    return (
      <>
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <header className={`floating-nav-wrapper ${scrolled ? 'nav-scrolled' : ''}`}>
        <nav className="capsule-nav" aria-label="Main navigation">
          <Link to="/" className="nav-brand" onClick={this.closeMobile} aria-label="Rudraksh Pathak - Home">
            <span className="brand-mark">RP</span>
            <div className="brand-text">
              <span className="brand-name">Rudraksh Pathak</span>
              <span className="brand-status">Application Architect</span>
            </div>
          </Link>

          <button
            className={`mobile-toggle ${mobileOpen ? 'active' : ''}`}
            onClick={this.toggleMobile}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-links ${mobileOpen ? 'open' : ''}`}>
            <li>
              <NavLink
                to="/"
                end
                onClick={this.closeMobile}
                className={({ isActive }) => `nav-item-link ${isActive ? 'active' : ''}`}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/showcase"
                onClick={this.closeMobile}
                className={({ isActive }) => `nav-item-link ${isActive ? 'active' : ''}`}
              >
                Showcase
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/bragging-rights"
                onClick={this.closeMobile}
                className={({ isActive }) => `nav-item-link ${isActive ? 'active' : ''}`}
              >
                Highlights
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/videos"
                onClick={this.closeMobile}
                className={({ isActive }) => `nav-item-link ${isActive ? 'active' : ''}`}
              >
                Videos
              </NavLink>
            </li>
            <li className="nav-cta-item">
              <a
                href="https://portfolio-rudraksh.s3.ap-south-1.amazonaws.com/rudraksh-pathak-resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-resume-btn"
                onClick={this.closeMobile}
              >
                <i className="fa fa-file-text-o"></i> Resume
              </a>
            </li>
          </ul>
        </nav>
      </header>
      </>
    );
  }
}

export default Header;
